import { render, staticRenderFns } from "./DomainsSettings.vue?vue&type=template&id=71abfa4f"
import script from "./DomainsSettings.vue?vue&type=script&lang=js"
export * from "./DomainsSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports